import { render, staticRenderFns } from "./FormAdmins.vue?vue&type=template&id=670bbbce"
import script from "./FormAdmins.vue?vue&type=script&lang=js"
export * from "./FormAdmins.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports